module.exports = __webpack_public_path__ + "img/poster.a6e77c68.png";